import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';

//local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/action-list';

const actionListWidgetSuccess = ( props ) => {
    return (
        <div className='ui-action-list-widget'>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }
                
                // updateTableOnChange={ true }
            />
        </div>
    );
};

// set display name
actionListWidgetSuccess.displayName = 'actionListWidgetSuccess';

// set default props
actionListWidgetSuccess.defaultProps = {
    componentData: {},
    layoutConfig: {},
    onActionClick: noop,
};

// prop types
actionListWidgetSuccess.propTypes = {};

/*******************************/
// preloader view
const actionListWidgetPreloader = ( props ) => {
    
    // widget class name
    const widgetClassName = classnames( 'ui-action-list-widget-preloader', props.className );
    return (
        <div className={ widgetClassName }>
            <TableSearchInlineWidgetPreloader />
        </div>
    );
};

// set display name
actionListWidgetPreloader.displayName = 'callListWidgetPreloader';

// set default props
actionListWidgetPreloader.defaultProps = {};

// prop types
actionListWidgetPreloader.propTypes = {};

/*******************************/
/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { actionListWidget as ActionListWidget } from 'ui/views/widgets/actionListWidget';
 *
 * // render
 * <ActionListWidget propName='propValue'/>
 */
export const actionListWidget = withNetworkState( actionListWidgetPreloader, actionListWidgetSuccess );
